import labels from "../config/labels"

const mappedStatus = {
  CREATE_MAGENTO_SUCCESS: labels.order_status_labels.lbl_processing,
  CREATE_EPPIX_FAILED: labels.order_status_labels.lbl_order_error,
  EPPIX_CREATE_TEMP_FAIL: labels.order_status_labels.lbl_processing,
  CREATE_EPPIX_SUCCESS: labels.order_status_labels.lbl_processing,
  CREATE_SUBMITTED_FAIL: labels.order_status_labels.lbl_processing,
  CREATE_SUBMIT_SUCCESS: labels.order_status_labels.lbl_processing,
  ZERO_VALUE_ORDER: labels.order_status_labels.lbl_processing,
  FORM_ENCRYPTION_FAILED: labels.order_status_labels.lbl_order_error,
  PAYMENT_INIT_FAILED: labels.order_status_labels.lbl_order_error,
  PAYMENT_INIT_SUCCESS: labels.order_status_labels.lbl_processing,
  PAYMENT_COMPLETE_FAILED: labels.order_status_labels.lbl_payment_failed,
  "Pending order countdown elapsed": labels.order_status_labels.lbl_cancelled,
  PAYMENT_COMPLETE_SUCCESS: labels.order_status_labels.lbl_processing,
  CQFD_SUBMIT_FAIL: labels.order_status_labels.lbl_order_error,
  CQFD_SUBMIT_TEMP_FAIL: labels.order_status_labels.lbl_processing,
  CQFD_SUBMIT_SUCCESS: labels.order_status_labels.lbl_processing,
  CREATE_L500_FAILED: labels.order_status_labels.lbl_processing,
  CREATE_L500_SUCCESS: labels.order_status_labels.lbl_processing,
  MULTI_PAYMENT_SETTLE_FAILED: labels.order_status_labels.lbl_order_error,
  PAYMENT_SETTLED_FAILED: labels.order_status_labels.lbl_order_error,
  PAYMENT_SETTLED_SUCCESS: labels.order_status_labels.lbl_paid,
  UPDATE_L500_FAILED: labels.order_status_labels.lbl_processing,
  UPDATE_L500_SUCCESS: labels.order_status_labels.lbl_processing,
  UPDATE_EPPIX_FAILED: labels.order_status_labels.lbl_processing,
  UPDATE_EPPIX_SUCCESS: labels.order_status_labels.lbl_processing,
  ORDER_COMPLETE_SUCCESS: labels.order_status_labels.lbl_processed
}

let mappedStyles = { x: 'a' };
mappedStyles[labels.order_status_labels.lbl_processing] = "order-status--processing";
mappedStyles[labels.order_status_labels.lbl_paid] = "order-status--processing";
mappedStyles[labels.order_status_labels.lbl_processed] = "order-status--processed";
mappedStyles[labels.order_status_labels.lbl_order_error] = "order-status--error";
mappedStyles[labels.order_status_labels.lbl_payment_failed] = "order-status--error";
mappedStyles[labels.order_status_labels.lbl_cancelled] = "order-status--cancelled";

let mappedIcons = { x: 'a' };
mappedIcons[labels.order_status_labels.lbl_processing] = "sync.svg";
mappedIcons[labels.order_status_labels.lbl_paid] = "sync.svg";
mappedIcons[labels.order_status_labels.lbl_processed] = "success-circle.svg";
mappedIcons[labels.order_status_labels.lbl_order_error] = "warning.svg";
mappedIcons[labels.order_status_labels.lbl_payment_failed] = "warning.svg";
mappedIcons[labels.order_status_labels.lbl_cancelled] = "icon-cross.svg";

export default {
  mappedStatus,
  mappedStyles,
  mappedIcons,
}
